var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPublichealthwellbeing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 116.629,
    height: 116.629,
    viewBox: "0 0 30.858 30.858",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -266.142)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 15.429,
    cy: 281.571,
    cx: 15.429,
    style: {
      fill: "#40a073",
      fillOpacity: 1,
      strokeWidth: 0.46499997
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff",
      strokeWidth: 1.20943701
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m405.7 165.4-16.9 6.4c-6.3 2.4-12.9 3.6-19.6 3.6-1.4 0-2.9-.1-4.3-.2-18.8-1.4-51.9-4-73.2-5.6L256 206.4l-36-37.2c-15.6-16-37-25.1-59.3-25.1h-.7c-10.6.1-21.1 2.2-30.8 6.4l-.8.3c-9.6 4.2-18.3 10.4-25.5 18.1-30.9 33.6-30.5 85.4 1 118.4l48.4 50c21.2 1.6 54.7 4.2 73.8 5.6 11.9.9 22.3 8.5 26.7 19.6l.2.5c6.3 15.8-1.4 33.7-17.2 40-2.1.8-4.3 1.4-6.5 1.8l-23.7 3.9 24.9 10.6c6 2.6 12.8 2.6 18.9 0l53-22.7 105.7-109.3c31.5-33 31.9-84.8 1-118.4-1.1-1.2-2.2-2.4-3.4-3.5zM240 280h-32v32h-32v-32h-32v-32h32v-32h32v32h32zm96 8-16 8v48h-32v-48l-16-8v-30.1c0-6.1 3.4-11.6 8.8-14.3L304 232l-7.2-3.6c-5.4-2.7-8.8-8.3-8.8-14.3v-4.2c0-8.8 7.2-16 16-16s16 7.2 16 16v4.2c0 6.1-3.4 11.6-8.8 14.3L304 232l23.2 11.6c5.4 2.7 8.8 8.3 8.8 14.3zM32 376h32v88H32z",
    style: {
      fill: "#fff",
      strokeWidth: 1.20943701
    },
    transform: "matrix(.04273 0 0 .04273 4.326 270.197)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m407.3 45.1-28.6-11.4c-2.8-1.1-5.9-1.7-8.9-1.7h-121c-4.3 0-8.6 1.2-12.3 3.4l-132.1 79.3c-6.3 3.8-8.4 12-4.6 18.3 3.4 5.7 10.6 8 16.7 5.4l4.4-1.9c1.2-.5 2.3-1 3.5-1.5L272 71.3l63.9 27.2 14.9-2.4 2.6 15.8-68.2 11.1c-8.1 1.3-13.5 8.9-12.2 17 .2 1.1.5 2.1.9 3.1l.2.5c2.1 5.5 7.2 9.2 13 9.6 20.8 1.5 58.4 4.4 78.9 6 5.8.5 11.6-.4 17.1-2.4l48.9-18.3V48h-9.8c-5.1 0-10.2-1-14.9-2.9zM448 48h32v88h-32zM395.9 373.9 255.7 434c-10 4.3-21.4 4.3-31.4 0l-48.1-20.5-14.9 2.4-2.6-15.8 68.1-11.1c8.1-1.3 13.5-8.9 12.2-17-.2-1.1-.5-2.1-.9-3.1l-.2-.5c-2.1-5.5-7.2-9.2-13-9.6-20.8-1.5-58.4-4.4-78.9-6-5.8-.5-11.6.4-17.1 2.4L80 373.5V464h9.8c5.1 0 10.1 1 14.9 2.9l28.6 11.4c2.8 1.1 5.9 1.7 8.9 1.7h121c4.3 0 8.6-1.2 12.3-3.4l132.3-79.4c6.2-3.7 8.2-11.8 4.5-18-3.4-5.6-10.4-7.9-16.4-5.3z",
    style: {
      fill: "#fff",
      strokeWidth: 1.20943701
    },
    transform: "matrix(.04273 0 0 .04273 4.326 270.197)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublichealthwellbeing);
export default __webpack_public_path__ + "static/media/Public health & wellbeing.e2b1e5355538fdc2a4035d38526d75e6.svg";
export { ForwardRef as ReactComponent };